import {IFullTemplateField} from '../_interface/itemplate-field';
import {FieldGroupTypeEnum} from '../_interface/field-group-type.enum';

export const filterComplexTemplateFields = (f: IFullTemplateField[]): IFullTemplateField[] => {
	return f.filter(t => t.groupType === FieldGroupTypeEnum.complex);
};
